<template>
  <ABadge class="bg-red-600 text-white">
    <template #icon>
      <Icon height="16" width="16" class="mr-1" />
    </template>
    <span v-if="diff < 86400">Order within {{ countdown }}</span>
    <span v-else>Get it by Christmas</span>
  </ABadge>
</template>

<script>
import ABadge from '../ABadge.vue'
import Icon from '../icons/ChristmasGift.vue'

export default {
  components: {
    ABadge,
    Icon,
  },
  data() {
    return {
      interval: null,
      diff: null,
    }
  },
  props: {
    time: {
      type: Date,
      required: true,
    },
  },
  computed: {
    countdown() {
      return new Date(this.diff * 1000).toISOString().slice(11, 19)
    },
  },
  mounted() {
    this.updateDiff()
    this.interval = setInterval(this.updateDiff, 1000)
  },
  unmounted() {
    this.interval && clearInterval(this.interval)
  },
  methods: {
    updateDiff() {
      this.diff = (this.time.getTime() - new Date().getTime()) / 1000
    },
  },
}
</script>
